<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" v-if="component">Редактировать ингредиент</h3>
        <h3 class="modal-title" v-else>Добавить ингредиент</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Наименование</label>
          <input type="text" class="form-control" v-model="name">
        </div>
        <div class="form-group">
          <label>Единица измерения</label>
        <v-multiselect
          v-model="measure"
          :options="types"
          :taggable="true"
          @tag="addTag"
        />
        </div>
      </div>
      <div class="modal-footer d-flex">
          <btn-action
            class="btn btn-outline-primary ml-auto"
            :disabled="!name"
            @click="save"
          >Сохранить</btn-action>
        </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'

  export default {
    props: ['component'],
    data () {
      return {
        name: this.component ? this.component.name : '',
        measure: this.component ? this.component.measure : 'шт',
        types: [
          'шт',
          'л',
          'кг',
        ],
      }
    },
    methods: {
      save () {
        const data = {
          name: this.name,
          measure: this.measure,
        }
        if (this.component) {
          api.put(`components/${this.component.id}`, data).then(() => this.hide(true))
        } else {
          api.post('components', data).then(() => this.hide(true))
        }
      },
      hide (refresh = false) {
        this.$emit('hide', {
          refresh: refresh,
        })
      },
      addTag (tag) {
        this.types.push(tag)
        this.measure = tag
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/recipes/component-modal.vue